import { styled, Flex, Box } from '@acko-tech/building-blocks.ui.common'

export const TabItemRootContainer = styled(Flex)`
  flex-basis: ${props => (props.isFloater || props.isBlog ? '20%' : '10%')};

  @media screen and (max-width: 425px) {
    flex-basis: 20%;
  }
`

export const TabItemImageContainerBase = styled(Flex)`
  width: 46px;
  height: 46px;
  border-radius: 36px;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease-in;
`

export const ItemImageRootContainer = styled(Box)`
  min-height: 58px;
  cursor: pointer;
`

export const ItemImageContainer = styled(TabItemImageContainerBase)`
  background-color: ${props => (props.isActive ? props.theme.colors.light.primary.n0 : '')};
`

export const TabItemText = styled(Flex)`
  font-size: ${props => props.theme.typography.fonts.size.P1};
  font-weight: ${props => props.theme.typography.fonts.weight.C1};
  line-height: ${props => props.theme.typography.lineHeights.P1};
  margin-top: 12px;
  margin-bottom: 12px;
  width: initial;
  color: ${props => (props.isFloater ? '#622BC9' : (props.isActive ? props.theme.colors.light.primary.n0 : '#D1C0FF'))};
  font-weight: ${props => (props.isActive ? '600' : '400')};
  padding-left: 10px;
  cursor: pointer;
`
